export const HIGH_RISK = new Set(['infected_cluster', 'cuit_funnel', 'shared_card', 'repeat_passengers'])

const SEVERITIES = ['hard', 'medium', 'soft']

export const SEVERITY_LABELS = { hard: 'Dura', medium: 'Media', soft: 'Blanda' }

const SEVERITY_RANK = { hard: 0, medium: 1, soft: 2 }

export function severityOf(flag) {
  if (flag && SEVERITIES.includes(flag.severity)) return flag.severity
  return flag && HIGH_RISK.has(flag.code) ? 'hard' : 'medium'
}

export function bySeverity(flags) {
  return [...(flags || [])].sort((a, b) => SEVERITY_RANK[severityOf(a)] - SEVERITY_RANK[severityOf(b)])
}
